import { LoginModule } from '@blade/common/store/login';
import { reactive, toRefs } from 'vue';
import moment from 'moment';
import { dashboardConfig, fetchWeather } from '@blade-sxp/screen-new/api/index';
import { MAP_ITEMS } from '@blade-sxp/screen-new/components/screen-head/const';
import { useMapStore } from '@blade-sxp/screen-new/store/map';
const store = useMapStore();
// 获取logo图片
export const getDefaultLogo = () => {
    const defaultLogo = reactive({
        defaultLogoUrl: LoginModule?.logoConfig?.defaultLogoUrl,
        defaultLogoName: LoginModule?.logoConfig?.systemName
    });
    return toRefs(defaultLogo);
};
// 获取天气信息
export const getWeather = async () => {
    const dateTime = moment().format('YYYY-MM-DD HH:mm:ss');
    const data = (await fetchWeather({ dateTime }));
    const weatherData = reactive({
        celsius: data.celsius,
        weather: data.weatherText // 温度
    });
    store.sysWeather = weatherData.weather || 'sunny';
    return toRefs(weatherData);
};
// 获取大屏切换选项
export function setDashboard() {
    const data = reactive({
        mapItems: null
    });
    const fetchData = async () => {
        const { MAP: mapData = [] } = (await dashboardConfig());
        data.mapItems = await mapData.map((item) => {
            const curr = MAP_ITEMS.find((map) => map.cardId === item.cardId);
            return {
                ...item,
                name: item.cardName,
                path: curr?.path,
                snapShot: curr?.snapShot,
            };
        });
    };
    fetchData();
    return toRefs(data);
}
